import { memo } from 'react';

import EnumSelect from 'components/field/EnumSelect';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import useAccessControl from 'hooks/useAccessControl';
import { DOTS, usePagination } from 'hooks/usePagination';

import { faAngleLeft, faAngleRight } from '@fortawesome/pro-solid-svg-icons';

import * as S from './DynamicListPagination.styled';

/**
 * @author @buunsal
 */
const DynamicListPagination = (props) => {
	const {
		currentPage,
		totalCount,
		pageSize,
		onPageChange,
		setPageSize,
		siblingCount = 1,
		containerStyle,
		style
	} = props;
	const isAuthorized = useAccessControl();

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize
	});

	// If there are less than 2 times in pagination range we shall not render the component
	if (currentPage === 0) {
		return null;
	}
	const pageSizeChanger = (value) => {
		onPageChange(1);
		setPageSize(value);
	};
	const onNext = () => {
		onPageChange(currentPage + 1);
	};

	const onPrevious = () => {
		onPageChange(currentPage - 1);
	};
	const lastPage = paginationRange[paginationRange.length - 1];
	return (
		<S.PaginationContainer style={containerStyle}>
			<EnumSelect
				data={
					isAuthorized('DynamicListExtendedPagination')
						? [5, 10, 20, 50, 100, 250, 500, 1000]
						: [5, 10, 20, 50, 100]
				}
				value={pageSize ?? 10}
				setValue={pageSizeChanger}
				valueRemovable={false}
				searchable={false}
				fixedContainerWidth={false}
			/>
			<Typography fontWeight="500" className="px-2">
				totalCountSeperator
			</Typography>
			<Typography fontWeight="500" className="totalCount">
				{totalCount}
			</Typography>
			<S.PaginationUL style={style}>
				{/* Left navigation arrow */}
				<S.IconContainer disabled={currentPage === 1 || totalCount === 0} onClick={onPrevious}>
					<Icon
						icon={faAngleLeft}
						color={currentPage !== 1 && totalCount !== 0 ? undefined : 'var(--content-4)'}
					/>
				</S.IconContainer>
				{paginationRange.map((pageNumber, index) => {
					// If the pageItem is a DOT, render the DOTS unicode character
					if (pageNumber === DOTS) {
						return (
							<li key={index} className="dots">
								&#8230;
							</li>
						);
					}

					// Render our Page Pills
					return (
						<li
							key={index}
							className={pageNumber === currentPage ? 'selected' : null}
							onClick={() => onPageChange(pageNumber)}>
							<span>{pageNumber}</span>
						</li>
					);
				})}
				{paginationRange.length === 0 && (
					<li className={'selected'}>
						<span>1</span>
					</li>
				)}
				{/*  Right Navigation arrow */}
				<S.IconContainer disabled={currentPage === lastPage || totalCount === 0} onClick={onNext}>
					<Icon
						icon={faAngleRight}
						color={currentPage !== lastPage && totalCount !== 0 ? undefined : 'var(--content-4)'}
					/>
				</S.IconContainer>
			</S.PaginationUL>
		</S.PaginationContainer>
	);
};

export default memo(DynamicListPagination);
